<template>
  <v-card v-if="scenarioStatsChartData.length" class="mb-5">
    <v-card-text class="pa-5">
      <div class="d-sm-flex align-center">
        <div>
          <h3 class="title font-weight-regular">
            <span class="lstick" />
            {{ $t('pages.statistics.scenarioStatistics') }}
          </h3>
        </div>
      </div>

      <div class="mt-2">
        <vue-apex-charts
          class="chart"
          height="390"
          :series="preparedData"
          :options="chartOptions"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import VueApexCharts from 'vue-apexcharts';

  import formatTimestampMixin from 'src/mixins/formatTimestampMixin';

  export default {
    name: 'ScenarioStatsChart',

    components: {
      VueApexCharts,
    },

    mixins: [formatTimestampMixin],

    data() {
      return {
        chartOptions: Object.freeze({
          chart: {
            height: 370,
            type: 'area',
            stacked: false,
            fontFamily: 'Montserrat,sans-serif',
            toolbar: {
              show: false,
            },
          },

          dataLabels: {
            enabled: false,
          },

          markers: {
            size: 3,
            strokeColors: 'transparent',
          },

          stroke: {
            curve: 'smooth',
            width: '2',
          },

          colors: ['#abceff', '#398bf7', '#7460ee', '#9c94ee'],

          legend: {
            show: false,
          },

          grid: {
            show: true,
            strokeDashArray: 0,
            borderColor: 'rgba(0,0,0,0.1)',
            yaxis: {
              show: false,
            },
            padding: {
              left: 30,
              right: 30,
            },
          },

          yaxis: {
            labels: {
              formatter: value => {
                return String(value);
              },

              style: {
                colors: '#a1aab2',
              },
            },
          },

          tooltip: {
            theme: 'dark',
            fillColors: ['#abceff', '#398bf7', '#7460ee', '#9c94ee'],
            y: {
              title: {
                formatter: type => `${this.$t(`pages.statistics.charts.${type}`)}:`,
              },
            },
          },
        }),
      };
    },

    computed: {
      ...mapState('stats', ['scenarioStatsChartData']),

      preparedData() {
        return this.scenarioStatsChartData.map(item => ({
          ...item,
          data: item.data.map(dataItem => ({ ...dataItem, x: this.formatDate(dataItem.x) })),
        }));
      },
    },
  };
</script>

<style scoped>
  .chart {
    position: relative;
    width: 100%;
    height: 350px;
  }
</style>
